import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import * as EventsActions from './events.actions';
import { EventsEntity } from './models/events-entity';

export const EVENTS_FEATURE_KEY = 'events';

export interface State extends EntityState<EventsEntity> {
  selectedId?: string | number; // which Events record has been selected
  loaded: boolean; // has the Events list been loaded
  error?: string | null; // last known error (if any)
}

export interface EventsPartialState {
  readonly [EVENTS_FEATURE_KEY]: State;
}

export const eventsAdapter: EntityAdapter<EventsEntity> =
  createEntityAdapter<EventsEntity>();

export const initialState: State = eventsAdapter.getInitialState({
  // set initial required properties
  loaded: false,
});

const eventsReducer = createReducer(
  initialState,
  on(EventsActions.init, (state) => ({ ...state, loaded: false, error: null })),
  on(EventsActions.loadEventsSuccess, (state, { events }) =>
    eventsAdapter.setAll(events, { ...state, loaded: true })
  ),
  on(EventsActions.loadEventsFailure, (state, { error }) => ({
    ...state,
    error,
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return eventsReducer(state, action);
}
